export default "__VITE_ASSET__CoLyurM1__"